var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { getStatusTranslation } from "../../utils/getStatusTranslation";
import { PublisherPrefixHistorySection } from "../../components/PublisherPrefixHistorySection";
import { CopyableId } from "../../components/CopyableId";
import { PublicCatalogLink } from "../../components/PublicCatalogLink";
export var PublisherDetail = function (_a) {
    var publisher = _a.publisher;
    var intl = useIntl();
    var _b = useState({
        general: true,
        history: true,
    }), accordionStatus = _b[0], setAccordionStatus = _b[1];
    var _c = useState(true), expandAll = _c[0], setExpandAll = _c[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                history: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                history: true,
            });
        }
        setExpandAll(!expandAll);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.publisher.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher.sourceId.field.label", value: React.createElement(React.Fragment, null,
                                React.createElement(CopyableId, { value: publisher.sourceId }),
                                React.createElement(PublicCatalogLink, { record: publisher, notPublicMessageId: "ui-br-agency.publicCatalog.publisher.notPublic" })) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher.name.field.label", value: publisher.name })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher.nameSuffix.field.label", value: publisher.nameSuffix }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher.qualifier.field.label", value: publisher.qualifier })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher.status.field.label", value: getStatusTranslation(intl, publisher.status) })))),
            React.createElement(AccordionSection, { id: "prefix-history-info", labelId: "ui-br-agency.publisher.accordions.label.prefixHistory", open: accordionStatus.history, onToggle: function () { return toggleAccordion("history"); } },
                React.createElement(PublisherPrefixHistorySection, { publisherId: publisher.id })))));
};
